import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { QueryBuilderModule } from 'angular2-query-builder';
import { QRCodeModule } from 'angularx-qrcode';
import { LightboxModule } from 'ngx-lightbox';
import { NgxMaskModule } from 'ngx-mask';
import { MomentModule } from 'ngx-moment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ComponentsModule } from './components/components.module';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GoogleMapsModule,
    TranslateModule,
    ComponentsModule,
    LayoutModule,
    MomentModule,
    QueryBuilderModule,
    NgxMaskModule,
    LightboxModule,
    NgxChartsModule,
    QRCodeModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GoogleMapsModule,
    NgxPermissionsModule,
    MaterialModule,
    ComponentsModule,
    TranslateModule,
    LayoutModule,
    MomentModule,
    QueryBuilderModule,
    NgxMaskModule,
    LightboxModule,
    NgxChartsModule,
    QRCodeModule
  ]
})
export class SharedModule {}
